import React from 'react';
import PropTypes from 'prop-types';

import PreviewBig from './components/PreviewBig';
import Row from './components/Row';
import Col from './components/Col';
import Preview from './components/Preview';
import { ITEM_TYPES } from '../../constants';

const ContentRows = ({ items, page }) => (
  <React.Fragment>
    {items.map((row, index) => (
      <Row key={index} index={index}>
        {!Array.isArray(row) ? (
          <PreviewBig {...row} />
        ) : (
          row.map(rowItem => (
            <Col key={rowItem.id} size={rowItem.size}>
              <Preview {...rowItem} alt={rowItem.title} page={page} size={rowItem.size} />
            </Col>
          ))
        )}
      </Row>
    ))}
  </React.Fragment>
);

ContentRows.propTypes = {
  items: PropTypes.array.isRequired,
  page: PropTypes.oneOf([ITEM_TYPES.case, ITEM_TYPES.news]),
};

export default ContentRows;



// WEBPACK FOOTER //
// ./src/components/ContentRows/index.js